import { Group, GroupOfUser, User } from '@era/security-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const UserGroupResolverActions = createActionGroup({
  source: 'User Group Resolver',
  events: {
    'User groups requested': props<{ userId: string }>(),
  },
});

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MembershipListUIActions = createActionGroup({
  source: 'Membership List UI',
  events: {
    'User group added': props<{ group: Group; userToAdd: User }>(),
    'User group deleted': props<{ group: Group; user: User }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MembershipListApiActions = createActionGroup({
  source: 'Membership List API',
  events: {
    'User group added': props<{ group: Group; userToAdd: User }>(),
    'User group deleted': props<{ group: Group; user: User }>(),
  },
});

export const UserApiActions = createActionGroup({
  source: 'User API',
  events: {
    'User groups loaded': props<{ groups: GroupOfUser[] }>(),
    'User groups loaded error': props<{ error: ErrorModel }>(),
  },
});

export const GroupApiActions = createActionGroup({
  source: 'Group API',
  events: {
    'User groups group deleted error': props<{ error: ErrorModel }>(),
    'User group added error': props<{ error: ErrorModel }>(),
  },
});
